import { render } from "./EmployeePhoto.vue?vue&type=template&id=2a10f292&scoped=true"
import script from "./EmployeePhoto.vue?vue&type=script&lang=js"
export * from "./EmployeePhoto.vue?vue&type=script&lang=js"

import "./EmployeePhoto.vue?vue&type=style&index=0&id=2a10f292&scoped=true&lang=less"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a10f292"]])

export default __exports__